export default "__VITE_ASSET__ChjOrexi__"